import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import classnames from 'classnames';
import { component } from './styles.module.scss';
import { faNotesMedical } from '@fortawesome/free-solid-svg-icons';

const SourceLinks = (props) => {
  const sources = props.sources;
  // console.log(sources);

  return (
    <div className={classnames(component)}>
      <div>
        <ul>
          {sources.map((item, i) => {
            return (
              <li key={i}>
                <a href={item.link} target='_blank' rel='noreferrer'>
                  <span className='icon'>
                    <FontAwesomeIcon icon={faNotesMedical} />
                  </span>
                  <span className='text'>
                    <strong>Check the latest updates</strong> <br />{item.title}
                  </span>
                </a>
              </li>
            );
          })}
        </ul>
      </div>
    </div>

  );
};

export default SourceLinks;
